module.exports = __webpack_public_path__ + "images/company/covid19/top_image_d1909ab660dcbf504875d5076cb3723c.png";